import styled from 'styled-components';

// Lays out the input; InputArea inside provides the card visual.
export const Base = styled.div`
	display: flex;
	flex-direction: column;
`;

interface InputAreaProps {
	isFocused: boolean;
}

// Visible border + matching radius; overflow clips inner Wrapper's square corners.
export const InputArea = styled.div<InputAreaProps>`
	width: 100%;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;
	border: 1px solid
		${({ isFocused, theme }) => (isFocused ? theme.gray[400] : theme.gray[200])};
	transition: border-color 0.12s ease;
	overflow: hidden;
`;

export const MultilineInputWrapper = styled.div`
	max-height: 120px;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.gray[400]};
		border-radius: 3px;
	}
`;

export const Actions = styled.div`
	// layout
	padding: 4px;
	display: flex;
	justify-content: flex-end;
	gap: 4px;

	// style
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const SubmitButtonWrapper = styled.div`
	padding-top: 4px;
`;

export const ReadOnlyText = styled.div`
	padding: 16px;
	text-align: left;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	line-height: 18px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;
